import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";
import { ProfileInfoCard, StatusBadge } from "@components";

const SharedSubTasksListTableColumn = (
  t: TFunction<"translation", undefined>,
) => {
  const { language } = useLanguage();

  return [
    {
      id: 1,
      key: "subTaskNo",
      name: t("TM_SHARED_SUB_TASKS.TASKS_LIST.TABLE.COLUMN.TASK_NO"),
      render: (subTaskNo: number, row: any) => {
        return <Text color="subtitle1">{subTaskNo}</Text>;
      },
    },
    {
      id: 2,
      key: "subtaskName",
      name: t("TM_SHARED_SUB_TASKS.TASKS_LIST.TABLE.COLUMN.NAME"),
      render: (subtaskName: string, row: any) => {
        return <Text color="subtitle1">{subtaskName}</Text>;
      },
    },
    {
      id: 3,
      key: "details",
      name: t("TM_SHARED_SUB_TASKS.TASKS_LIST.TABLE.COLUMN.DETAILS"),
      render: (details: string) => (
        <Text color="subtitle1">{details || "--"}</Text>
      ),
    },

    {
      id: 4,
      key: "AssignedPerson",
      name: t("TM_SHARED_SUB_TASKS.TASKS_LIST.TABLE.COLUMN.ASSIGNED_PERSON"),
      render: (AssignedPerson: any, row: any) => {
        return AssignedPerson ? (
          <ProfileInfoCard employee={AssignedPerson} />
        ) : (
          "--"
        );
      },
    },

    {
      id: 5,
      key: "status",
      name: t("TM_SHARED_SUB_TASKS.TASKS_LIST.TABLE.COLUMN.STATUS"),
      render: (status: string) => {
        return <StatusBadge status={status} />;
      },
    },
    {
      id: 6,
      key: "priority",
      name: t("TM_SHARED_SUB_TASKS.TASKS_LIST.TABLE.COLUMN.PRIORITY"),
      render: (priority: string | number) => {
        return priority ? <StatusBadge status={`${priority}`} /> : "--";
      },
    },
  ];
};

export default SharedSubTasksListTableColumn;
